import { LinearTransform } from '@st/geom'
import { PDFPageStructure, PageStructure } from '../../models'

const DEFAULT_DELETED_PAGE_COLLAPSED_HEIGHT_PX = 24

export type DeletedPagePolicy = { collapsedHeightPx?: number }

export function resolveMuPDFPages({
  pages,
  pageRotations,
  deletedPageNumbers,
  deletedPagePolicy
}: {
  pages: PageStructure[]
  pageRotations?: Record<string, number>
  deletedPageNumbers?: number[]
  deletedPagePolicy?: DeletedPagePolicy
}): PDFPageStructure[] {
  const resolvedPages = pages.map((page): PDFPageStructure => {
    const rotation = pageRotations?.[page.pageNumber] ?? 0
    const isDeleted = deletedPageNumbers?.includes(page.pageNumber) ?? false
    const collapsedHeightPx =
      deletedPagePolicy?.collapsedHeightPx ?? DEFAULT_DELETED_PAGE_COLLAPSED_HEIGHT_PX
    const bounds = isDeleted
      ? {
          ...page.bounds,
          width: page.bounds.width,
          height: collapsedHeightPx
        }
      : LinearTransform.apply(page.bounds, LinearTransform.pageRotate(rotation, page.bounds))

    return {
      ...page,
      sourceBounds: page.bounds,
      rotation: rotation,
      isDeleted: isDeleted,
      bounds: bounds
    }
  })

  const pagesByNumber = new Map(resolvedPages.map((page) => [page.pageNumber, page]))

  return resolvedPages.map((page) => ({
    ...page,
    links: page.links.map((link) => {
      const targetPage = pagesByNumber.get(link.destination.pageNumber)
      const targetBounds = link.destination.bounds

      if (!targetPage) {
        throw new Error(`Internal link targets missing page ${link.destination.pageNumber}`)
      }
      if (!targetBounds || targetPage.rotation == 0) return link

      return {
        ...link,
        destination: {
          ...link.destination,
          bounds: LinearTransform.apply(
            targetBounds,
            LinearTransform.pageRotate(targetPage.rotation, targetPage.sourceBounds)
          )
        }
      }
    })
  }))
}
